import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';

// TODO: Import slices here
// import stocksReducer from './slices/stocksSlice';
// import predictionsReducer from './slices/predictionsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    // TODO: Add reducers here
    // stocks: stocksReducer,
    // predictions: predictionsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
